import axios from 'axios';

export class GlobalConfiguration {
    /**
     * L'URL de l'application portant l'API.
     */
    public static apiUrl = '';

    /**
     * L'URL de l'application web (front) GESGO.
     */
    public static gesgoUrl = '';

        /**
     * L'URL de l'application web (front) GESGO 2.
     */
    public static gesgo2Url = '';

    /**
     * Le nom de l'environnement.
     */
    public static environmentName = '';

    /**
     * Adresse authentification d'okta.
     */
    public static oktaIssuer = '';

    /**
     * Identitifiant du client okta.
     */
    public static oktaClientId = '';

    /**
     * Récupération des variables dans le parameters.json
     */
    public static async read(): Promise<void> {
        return axios.get('/parameters.json').then((parameters) => {
            this.apiUrl = parameters.data.API_URL;
            this.environmentName = parameters.data.EnvironmentName;
            this.oktaIssuer = parameters.data.OKTA_ISSUER;
            this.oktaClientId = parameters.data.OKTA_CLIENT_ID;
            this.gesgoUrl = parameters.data.GESGO_URL;
            this.gesgo2Url = parameters.data.GESGO_2_URL;
        });
    }
}